import { FullScreenVideo } from "@components/fullScreenVideo";
import { Modal } from "@components/shared";
import ExperienceCard from "@components/spotprofile/experience-card";
import ExperiencesFilters, {
  type ExperiencesFilterOptions,
} from "@components/spotprofile/experiences-filters";
import SpotProfileLayout from "@layouts/SpotProfileLayout";
import Tab from "@components/spotprofile/tab";
import {
  getSpotCategories,
  getSpotInfo,
  getSpotTopExperiences,
} from "@lib/api";
import type {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from "next";
import { useRouter } from "next/router";
import { CSSProperties, useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "@hooks/useTranslation";
import { events, track } from "@shared/tracking";

import type { Locale } from "../../../i18n-config";
import { MainLayout } from "@layouts/MainLayout";
import Head from "next/head";


// Import Swiper React components
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Image from "next/image";

// import required modules
import { FreeMode, Pagination, Navigation, Autoplay } from "swiper";
import { VideoJS } from "@components/VideoJS";
import { truncate } from "fs";

import Appstore from "../../../public/logo-appstore.svg";
import Googleplay from "../../../public/logo-googleplay.svg"
import Citation from "../../../public/images/theapp/signo-de-comillas-a-la-izquierda.png"
import InstaIcon from "../../../public/images/theapp/instagram.png"
import Ok from "../../../public/images/ok.png"
import { pickByLocale } from "@lib/utils";
import { useMobileDetect } from "@hooks/useMobileDetect";





export default function TheAppPage({
}) {
  const { t } = useTranslation();


  const router = useRouter();


  const locale = (router.locale ?? "en") as Locale;

  const [player, setPlayer] = useState<any>(null);
  const [player2, setPlayer2] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);



  const swiperRef = useRef<SwiperRef>(null);
  
  

  const description = pickByLocale(
    {
      en: "Book unique experiences in Barcelona, Marrakech, and Lisbon with beder. Discover the best activities and hotels through videos from other travelers. Press play, book, and enjoy the journey!",
      es: "Reserva experiencias únicas en Barcelona, Marrakech y Lisboa con beder. Descubre las mejores actividades y hoteles a través de vídeos de otros viajeros. ¡Dale al play, reserva y disfruta del viaje!",
      fr: "Réservez des expériences uniques à Barcelone, Marrakech et Lisbonne avec beder. Découvrez les meilleures activités et hôtels à travers des vidéos d’autres voyageurs. Appuyez sur play, réservez et profitez du voyage!",
    ru: "Бронируйте уникальные впечатления в Барселоне, Марракеше и Лиссабоне с beder. Открывайте лучшие развлечения и отели через видео от других путешественников. Нажмите «Play», забронируйте и наслаждайтесь путешествием!"
    },
    locale
  );

    const scrolltoHash = function (element_id: string) {
    const element = document.getElementById(element_id)
    element?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }

  const { isAndroid } = useMobileDetect();

  const handleGetTheApp = () => {
    const playStoreUrl =
      "https://play.google.com/store/apps/details?id=com.bederapp";
    const appStoreUrl =
      "https://apps.apple.com/app/beder-l-explore-travel/id1609301338";

    const appUrl = isAndroid() ? playStoreUrl : appStoreUrl;

    window.open(appUrl, "_blank", "noreferrer");
  };



  return (
    <MainLayout isFooter={true}>
       <Head>
        <title>Beder</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta httpEquiv="Content-Language" content="en,es,fr"></meta>
        <meta name="description" content={description} />
        <meta
          property="og:image"
          content="https://beder-sales.s3.eu-west-3.amazonaws.com/prod/styles/thumbnail/thumbnail.jpg"
          data-addsearch="no_crop"
        ></meta>
      </Head>






      
      <section className=" flex flex-col items-center justify-between  !w-full !h-[100%] ">

      <Swiper
           grabCursor={true}
           centeredSlides={true}

           initialSlide={0}
           autoplay={{
            disableOnInteraction: false,
            delay: 8000
          }}
           pagination={{
            clickable: true,
             enabled: true,
             bulletActiveClass: "!bg-primary-color !w-5 !h-5",
             bulletClass:
               "mx-3 mt-0 inline-block !w-4 !h-4 bg-gray-300/90 rounded-full ",
           }}
           modules={[ Pagination, Autoplay]}
           className="!h-[670px] w-[300%] md:!h-[800px]"
           ref={swiperRef}
           onActiveIndexChange={(swiper) => {
            setActiveIndex(swiper.activeIndex);
           /* if(swiper.activeIndex == 0)
              player?.play();
            else if(swiper.activeIndex == 1)
            player2?.play();*/
  
          }}
         >
      
        <SwiperSlide className=" !w-screen !h-[900px] ">
          <div className="
          w-[3900%]
          md:!w-[1900%] md:-ml-[450%] -ml-[450%] lg:ml-[0%]
           lg:!w-[1300%] xl:!w-[1150%]
           object-fill !h-[900px]
          items-center justify-center align-center content-center mt-0 overflow-x-hidden overflow-y-hidden">
            <div className="  justify-center align-center content-center mt-0">
              <VideoJS
                options={{
                  autoplay: true,
                  controls: false,
                  muted:true,
                  controlBar: {
                    fullscreenToggle: false,
                    pictureInPictureToggle: false,
                  },
                  loop: false,
                  fluid: true,
                   playsinline: true,
preload: "auto",
                }}
           
                src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Hero/1.mp4'}
                poster={''}
                play={activeIndex == 0}
      
                onReady={(playerRef) => {
                  setPlayer(playerRef);
        
                }}
                onPlay={player?.currentTime(0) &&

                    setActiveIndex(swiperRef.current!.swiper.activeIndex) }
                //onEnded={() => {
                 // swiperRef.current?.swiper.slideNext();
                //}}

              />
                <div className="top-[28%] absolute justify-center align-center content-center text-center mx-auto 
                              !w-[1900%]
                              lg:!w-[1000%]">
                  <h1 className="w-[100%] text-white lg:text-[70px] md:text-[50px] text-[30px] font-semibold">
                    <div className="visible md:hidden">LIFE IS SHORT,<br /> TRAVEL HARD</div>
                    <div className="invisible md:visible">LIFE IS SHORT, TRAVEL HARD</div>
                  </h1>
                  
                  <h2 className="text-[#1EA691] lg:text-[30px] md:text-[20px] text-[15px] font-bold">
                    {locale === 'es' ? 'Descubre qué vivir en tu ' 
                      : locale === 'en' ? 'Discover what to live in your ' 
                      : locale === 'fr' ? "Découvrez ce qu'il y a à vivre dans votre " 
                      : "Узнай что можно испытать в твоем "}
                    <br />
                    {locale === 'es' ? 'próximo destino' 
                      : locale === 'en' ? 'next destination' 
                      : locale === 'fr' ? 'prochaine destination' 
                      : 'следующем путешествии'}
                  </h2>
                  
                  <h3 className="text-white lg:text-[25px] md:text-[20px] text-[15px] font-normal">
                    {locale === 'es' ? 'Videos de los mejores lugares, experiencias ¡y más!' 
                      : locale === 'en' ? 'Videos of the best places and experiences.' 
                      : locale === 'fr' ? 'Vidéos des meilleurs endroits et expériences.' 
                      : 'Видео лучших мест и развлечений.'}
                    <br />
                    {locale === 'es' ? '¡Guárdalos en el mapa y vive tu mejor viaje!' 
                      : locale === 'en' ? 'Find them in a map & live your best trip.' 
                      : locale === 'fr' ? 'Trouvez-les sur une carte et vivez votre meilleur voyage.' 
                      : 'Сохраняй их на карте и наслаждайся лучшим путешествием!'}
                  </h3>

                  <div className="justify-center align-center content-center mt-10">
                    <div 
                      onClick={() => handleGetTheApp()}
                      className="bg-[#00F3CD] w-[150px] md:w-[200px] my-3 py-2 mx-auto rounded-[100px] 
                                font-bold cursor-pointer hover:bg-white 
                                border-[3px] border-[#00F3CD] text-[13px] md:text-[15px]">
                      {locale === 'es' ? 'DESCARGA LA APP' 
                        : locale === 'en' ? 'GET THE APP' 
                        : locale === 'fr' ? 'TÉLÉCHARGER L\'APPLICATION' 
                        : 'СКАЧАТЬ ПРИЛОЖЕНИЕ'}
                    </div>
                  </div>
                </div>




              </div>
          </div>
      </SwiperSlide>
      <SwiperSlide className=" !w-screen !h-screen  ">
          <div className="!w-[1000%] !h-[100%] ml-[900%] bg-white flex  items-center">
            <h2 className="w-1/3 lg:text-[60px] md:text-[45px] text-[30px] font-bold text-center">
  {locale === 'es' ? 'No lo leas,' : 
   locale === 'ru' ? 'Не читай,' : 
   locale === 'fr' ? 'Ne le lis pas,' : 
   `Don't read it`}
              </h2>
            <div className="w-1/3  flex  items-center justify-center">
              <div className="w-[100%] lg:w-[50%]">
                <VideoJS
                  options={{
                    autoplay: false,
                    controls: false,
                    controlBar: {
                      fullscreenToggle: false,
                      pictureInPictureToggle: false,
                    },
                    loop: false,
                    fluid: true,
                     playsinline: true,
preload: "auto",
                    muted:true,
                  }}
            
                  src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Hero/2.mp4'}
                  poster={''}
                  play={activeIndex === 1}
          
                  onReady={(playerRef2) => {
                    setPlayer2(playerRef2);
                  }}
                  onPlay={player2?.currentTime(0) &&
                  
                      setActiveIndex(swiperRef.current!.swiper.activeIndex) }
                  //onEnded={() => {
                  // swiperRef.current?.swiper.slideNext();
                // }}
                />
              </div>
             
              </div>
              <h2 className="w-1/3 lg:text-[60px] md:text-[45px] text-[30px] font-bold text-center text-[#00F3CD]">{locale == 'es' ? 'Vívelo' : 
 locale == 'en' ? 'Just enjoy it' : 
 locale == 'fr' ? 'Profitez-en' : 
 locale == 'ru' ? ' Просто наслаждайся' : 
 'Just enjoy it'}
</h2>
          </div>
      </SwiperSlide>
      <SwiperSlide className=" !w-screen !h-screen  ">
      <div className="!w-screen h-[100%] ml-[1800%] overflow-x-hidden overflow-y-hidden">
      <div className="flex flex-col w-[340%] md:w-[150%] lg:w-[100%] 
                    -ml-[120%] md:-ml-[0%]
                         h-[100%] 


      
       align-center text-center content-center justify-center items-center"
        
        style={{
          backgroundImage: `url(' https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Hero/3.jpg')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% auto',
          backgroundPosition: 'center',
        }}>
      
      </div>
      <div className="text-white flex flex-col text-black">
  <div className="text-[30px] md:text-[70px] text-white text-center 
          absolute top-40 w-screen leading-[1.1] font-semibold
          items-center mt-[200%] md:mt-[30%]">
    
    <h3>
      {locale === 'es' ? 'CONECTA CON TU' 
        : locale === 'en' ? 'CONNECT WITH YOUR' 
        : locale === 'fr' ? 'CONNECTEZ-VOUS À VOTRE' 
        : 'СОЕДИНИТЕСЬ СО СВОИМ'}  
      <br />
      {locale === 'es' ? 'LADO MÁS TRAVELLER EN be' 
        : locale === 'en' ? 'INNER TRAVELLER IN be' 
        : locale === 'fr' ? 'VOYAGEUR INTÉRIEUR DANS be' 
        : 'внутреннего путешественника вместе с be'}
      <span className="text-[#00F3CD]">der</span>
    </h3>

    <h2 className="text-[20px] md:text-[30px] mt-10">
      {locale === 'es' ? '¿Cúal es tu próximo destino?' 
        : locale === 'en' ? 'What is your next destination?' 
        : locale === 'fr' ? 'Quelle est votre prochaine destination ?' 
        : 'Куда ты отправишься в следующий раз?'}
    </h2>

    <div className="justify-center align-center content-center mt-10 text-[13px] md:text-[15px]">
      <div 
        onClick={() => handleGetTheApp()}
        className="bg-[#00F3CD] w-[150px] md:w-[200px] my-3 py-2 mx-auto rounded-[100px] 
                  font-bold cursor-pointer hover:bg-white 
                  border-[3px] border-[#00F3CD] text-black">
        {locale === 'es' ? 'DESCARGA LA APP' 
          : locale === 'en' ? 'GET THE APP' 
          : locale === 'fr' ? 'TÉLÉCHARGER L\'APPLICATION' 
          : 'СКАЧАТЬ ПРИЛОЖЕНИЕ'}
      </div>
    </div>
  </div>
</div>


     

          </div>
      </SwiperSlide>
      </Swiper>

      </section>
      <section className="invisible md:visible relative flex flex-row items-center justify-center bg-black text-black  h-[100px] z-20  sticky top-16 ">

      <div 
  className="font-semibold -mb-[20px] text-[#FFFFFF] opacity-90 text-center hover:text-[#00F3CD] transform hover:opacity-100 transition-opacity duration-300 cursor-pointer mx-auto" 
  onClick={() => scrolltoHash('BETHERE')}
>
  {locale === 'es' ? 'Experiencia' 
    : locale === 'en' ? 'The experience' 
    : locale === 'fr' ? `L'expérience` 
    : 'Опыт'}
  <div className="font-bold text-[60px] -mt-[60px] opacity-50 transform transition-opacity duration-300 hover:opacity-100 text-[#00F3CD]">
    __________
  </div>
</div>

<div 
  className="font-semibold -mb-[20px] text-[#FFFFFF] opacity-90 text-center hover:text-[#00F3CD] transform hover:opacity-100 transition-opacity duration-300 cursor-pointer mx-auto" 
  onClick={() => scrolltoHash('FINDWHATYOUNEED')}
>
  {locale === 'es' ? 'Explora y Siente' 
    : locale === 'en' ? 'Explore to Feel' 
    : locale === 'fr' ? 'Explorer pour Ressentir' 
    : 'Куда ты отправишься в следующий раз?'}
  <div className="font-bold text-[60px] -mt-[60px] opacity-50 transform transition-opacity duration-300 hover:opacity-100 text-[#00F3CD]">
    __________
  </div>
</div>

<div 
  className="font-semibold -mb-[20px] text-[#FFFFFF] opacity-90 text-center hover:text-[#00F3CD] transform hover:opacity-100 transition-opacity duration-300 cursor-pointer mx-auto" 
  onClick={() => scrolltoHash('COMMENTS')}
>
  {locale === 'es' ? 'Opiniones' 
    : locale === 'en' ? `Traveller's thoughts` 
    : locale === 'fr' ? 'Pensées du Voyageur' 
    : 'Мысли путешественника'}
  <div className="font-bold text-[60px] -mt-[60px] opacity-50 transform transition-opacity duration-300 hover:opacity-100 text-[#00F3CD]">
    __________
  </div>
</div>

<div 
  className="font-semibold -mb-[20px] text-[#FFFFFF] opacity-90 text-center hover:text-[#00F3CD] transform hover:opacity-100 transition-opacity duration-300 cursor-pointer mx-auto" 
  onClick={() => scrolltoHash('BREAKTHEROUTINE')}
>
  {locale === 'es' ? 'Rompe la Rutina' 
    : locale === 'en' ? 'Break the Routine' 
    : locale === 'fr' ? 'Casser la Routine' 
    : 'Разорви рутину'}
  <div className="font-bold text-[60px] -mt-[60px] opacity-50 transform transition-opacity duration-300 hover:opacity-100 text-[#00F3CD]">
    __________
  </div>
</div>

    

        
      </section>
      
      <section className="invisible md:visible relative flex flex-row items-center justify-center bg-black text-black  h-[0px] z-10 shadow-[0_0px_50px_60px_rgba(0,0,0,0.95)] h-[100px] bg-black"></section>


      <section className="relative flex flex-row items-center justify-center   pt-12  h-[600px] mb-[250px]">
      
      <div className="flex flex-row h-screen overflow-x-auto w-screen align-center text-center content-center justify-center items-center"
      
      style={{
        backgroundImage: `url('https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/hero-bottom.webp')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
<div>
  <div className="w-full">
    <h3 className="ml-5 leading-[1.1] text-[30px] md:text-[64px] font-bold text-white text-left align-center mr-5 justify-center content-center items-center">
      <p>
        {locale === 'es' ? 'Atrevidos, curiosos, inquietos' 
          : locale === 'en' ? 'Bold, curious, restless' 
          : locale === 'fr' ? 'Audacieux, curieux, agité' 
          : 'Ты смелый, дерзский и неутомимый'}
      </p>
    </h3>
  </div>

  <br className="w-full" />

  <div className="-mt-[20px] ml-5">
    <h6 className="text-[#00F3CD] w-full leading-[1.1] text-[50px] md:text-[75px] font-bold text-white text-left align-center mr-5 justify-center content-center items-center">
      <p>
        {locale === 'es' ? '¡Bienvenidos!' 
          : locale === 'en' ? 'Welcome!' 
          : locale === 'fr' ? 'Bienvenue!' 
          : 'Добро пожаловать!'}
      </p>
    </h6>
  </div>

  <br />

  <div className="text-white text-[20px] md:text-[25px] font-bold text-left w-[92%] md:w-[50%] ml-5">
    {locale === 'es' ? 
      'Descubramos nuevos rincones, conectemos con otras culturas, exploremos nuevos sabores, conozcamos gente por el camino y ¡vivamos momentos increíbles!' 
      : locale === 'en' ? 
      'Let’s discover new spots, connect with other cultures, explore new flavours, meet new people and live incredible moments!' 
      : locale === 'fr' ? 
      'Découvrons de nouveaux coins, connectons-nous avec d’autres cultures, explorons de nouvelles saveurs, rencontrons de nouvelles personnes et vivons des moments incroyables !' 
      : 'Давай вместе откроем новые места, узнаем о новых культурых, попробуем новые вкусы, встретим новых людей и проживем незабываемые моменты!'}
  </div>

  <div className="bg-[#00F3CD] font-bold text-[20px] md:text-[23px] w-[92%] md:w-[50%] ml-5 mr-5 mt-10 py-0.5 cursor-pointer"
       onClick={() => scrolltoHash('BETHERE')}>
    {locale === 'es' ? 'Atrevámonos y disfrutemos del mundo como nunca.' 
      : locale === 'en' ? 'Dare to enjoy the world as never before.' 
      : locale === 'fr' ? 'Osez profiter du monde comme jamais auparavant.' 
      : 'Рискни насладиться миром как никогда раньше!'}
  </div>
</div>

      </div>
    </section>






      <section id="BETHERE" className="relative flex flex-col items-center justify-center   pt-5 md:inline-grid md:grid-cols-2 md:gap-4 ml-[0%] lg:ml-[15%]">
        

        <div className="text-white flex flex-col mx-14 text-[18px] !text-black">
        <h3 className="text-2xl text-[#00F3CD] mb-5">BE THERE</h3>
<h4 className="text-[62px] font-bold leading-[60px] mb-10">
  {locale === 'es' ? 'Descubre y Guarda' 
    : locale === 'en' ? 'Discover and Save' 
    : locale === 'fr' ? 'Découvrez et Enregistrez' 
    : 'Открой и сохрания'}
</h4>

<p className="text-l mb-5">
  {locale === 'es' ? 'Explora el mundo, descubre lugares únicos y experiencias increíbles'
    : locale === 'en' ? 'Explore the world, discover unique places and incredible experiences'
    : locale === 'fr' ? 'Explorez le monde, découvrez des lieux uniques et des expériences incroyables'
    : 'Исследуй мир, открывай уникальные места и невероятные впечатления'}
</p>

<p className="text-l flex mb-5">
  <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt="" />
  {locale === 'es' ? 'Descubre qué puedes ver y vivir en cualquier destino'
    : locale === 'en' ? 'Discover what you can see and experience in any destination'
    : locale === 'fr' ? `Découvrez ce que vous pouvez voir et expérimenter dans n'importe quelle destination`
    : 'Узнай, что можно увидеть и испытать в любом месте'}
</p>

<p className="text-l flex mb-5">
  <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt="" />
  {locale === 'es' ? 'Explora a través de videos con la localización exacta, según el destino y la categoría'
    : locale === 'en' ? 'Explore through videos with exact location, according to destination and category'
    : locale === 'fr' ? 'Explorez à travers des vidéos avec localisation exacte, selon la destination et la catégorie'
    : 'Исследуй места через видео с точной геолокацией, с фильтрацией по месту и категориям'}
</p>

<p className="text-l flex mb-5">
  <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt="" />
  {locale === 'es' ? 'Guarda los lugares y experiencias que quieres vivir'
    : locale === 'en' ? 'Save the places and experiences you want to live'
    : locale === 'fr' ? 'Enregistrez les lieux et les expériences que vous souhaitez vivre'
    : 'Сохраняй места и впечатления, которые хочешь испытать'}
</p>
</div>

         <div className="flex items-center justify-center w-[400px] overflow-x-hidden mt-4">
         <Swiper style={{ "--swiper-navigation-color": '#00F3CD' }  as CSSProperties}
                    grabCursor={true}
               
              
                    initialSlide={1}
                    navigation={true}
                
                    centeredSlides={true}
                    slidesPerView={1}
                    spaceBetween={350}
                    autoplay={{
                      disableOnInteraction: false,
                      delay: 5000
                    }}
           
                    modules={[ Navigation, Autoplay]}
                    className="!h-[100] !w-[200%]"
                    >

                    <SwiperSlide  className=" "> <div className="!w-[1000%] ml-[4px]"> <Image quality={80}   src='https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Decide/1.webp' alt={""} width={600} height={500}/></div></SwiperSlide>
                    <SwiperSlide  className="">  <div className="!w-[1000%] ml-[364px]"> <Image quality={80}  src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Decide/2.webp'} alt={""} width={500} height={500}/></div></SwiperSlide>
                    <SwiperSlide  className="">  <div className="!w-[1000%] ml-[725px]"> <Image quality={80}  src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Decide/3.webp'} alt={""} width={500} height={500}/></div></SwiperSlide>
                    <SwiperSlide  className="">  <div className="!w-[1000%] ml-[1080px]"> <Image quality={80}  src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Decide/4.webp'} alt={""} width={500} height={500}/></div></SwiperSlide>

                </Swiper>
                </div>
                
    </section>


    <section id="FINDWHATYOUNEED" className="bg-black mt-20 pt-20 mb-20 pb-20">
  <div className="relative flex flex-col items-center justify-center pt-5 md:inline-grid md:grid-cols-2 md:gap-4 ml-[0%] lg:ml-[15%]">
    <div className="text-white flex flex-col mx-14 text-[18px] text-white md:hidden">
      <h3 className="text-2xl text-[#00F3CD] mb-5">
        {locale == 'es' ? 'FIND WHAT YOU NEED' : locale == 'en' ? 'FIND WHAT YOU NEED' : locale == 'fr' ? 'TROUVEZ CE DONT VOUS AVEZ BESOIN' : 'Найди, что тебе нужно'}
      </h3>
      <h4 className="text-[62px] font-bold text-white leading-[60px] mb-10">
        {locale == 'es' ? 'Decide y Vive' : locale == 'en' ? 'Decide and Live' : locale == 'fr' ? 'Décidez et Vivez' : 'Определись и вперед! '}
      </h4>
      <p className="text-l mb-5">
        {locale == 'es' ? 'Decide tu destino y crea memorias inolvidables' :
         locale == 'en' ? 'Decide your destination and create unforgettable memories' :
         locale == 'fr' ? 'Décidez de votre destination et créez des souvenirs inoubliables' : 'Определи пункт назначения и создавай незабываемые воспоминания'}
      </p>
      <p className="text-l flex mb-5">
        <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
        {locale == 'es' ? 'Une amigos a tus viajes para compartir vuestro contenido guardado' :
         locale == 'en' ? 'Join your friends to your trips and share your favourite content' :
         locale == 'fr' ? 'Rejoignez vos amis à vos voyages et partagez votre contenu préféré' : 'Делись своими поездками и любимым контентом со своими друзьями'}
      </p>
      <p className="text-l flex mb-5">
        <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
        {locale == 'es' ? 'Filtralo en el mapa según lo que te apetezca' :
         locale == 'en' ? 'Filter it in the map depending on your mood' :
         locale == 'fr' ? 'Filtrez-le dans la carte selon votre humeur' : 'Найди что тебе хочется на карте'}
      </p>
      <p className="text-l flex mb-5">
        <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
        {locale == 'es' ? 'Reserva experiencias, hoteles y vuelos con nuestros partners' :
         locale == 'en' ? 'Book experiences, hotels and flights with our partners' :
         locale == 'fr' ? 'Réservez des expériences, des hôtels et des vols avec nos partenaires' : 'Забронируй развлечения, отели и рейсы у наших партнеров'}
      </p>
    </div>
    <div className="flex items-center justify-center w-[400px] overflow-x-hidden mt-4">
      <Swiper
        style={{ "--swiper-navigation-color": '#00F3CD' } as CSSProperties}
        grabCursor={true}
        initialSlide={1}
        navigation={true}
        centeredSlides={true}
        slidesPerView={1}
        spaceBetween={350}
        autoplay={{
          disableOnInteraction: false,
          delay: 5000
        }}
        modules={[Navigation, Autoplay]}
        className="!h-[100] bg-black !w-[200%]"
      >
        <SwiperSlide className=" "> 
          <div className="!w-[1000%] ml-[4px]"> 
            <Image quality={80} src='https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Discover/1.webp' alt={""} width={500} height={500}/>
          </div>
        </SwiperSlide>
        <SwiperSlide className="">
          <div className="!w-[1000%] ml-[364px]">
            <Image quality={80} src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Discover/2.webp'} alt={""} width={500} height={500}/>
          </div>
        </SwiperSlide>
        <SwiperSlide className="">
          <div className="!w-[1000%] ml-[725px]">
            <Image quality={80} src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Discover/3.webp'} alt={""} width={500} height={500}/>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div className="text-white flex flex-col mx-14 text-[18px] text-white collapse h-0 md:visible md:h-[100%] md:mt-[10%]">
      <h3 className="text-2xl text-[#00F3CD] mb-5">
        {locale == 'es' ? 'FIND WHAT YOU NEED' : 
         locale == 'en' ? 'FIND WHAT YOU NEED' : 
         locale == 'fr' ? 'TROUVEZ CE DONT VOUS AVEZ BESOIN' : 'НАЙДИТЕ, ЧТО ВАМ НУЖНО'}
      </h3>
      <h4 className="text-[62px] font-bold text-white leading-[60px] mb-10">
        {locale == 'es' ? 'Decide y Vive' : 
         locale == 'en' ? 'Decide and Live' : 
         locale == 'fr' ? 'Décidez et Vivez' : 'Решите и живите'}
      </h4>
      <p className="text-l mb-5">
        {locale == 'es' ? 'Decide tu destino y crea memorias inolvidables' :
         locale == 'en' ? 'Decide your destination and create unforgettable memories' :
         locale == 'fr' ? 'Décidez de votre destination et créez des souvenirs inoubliables' : 'Решите ваш пункт назначения и создавайте незабываемые воспоминания'}
      </p>
      <p className="text-l flex mb-5">
        <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
        {locale == 'es' ? 'Une amigos a tus viajes para compartir vuestro contenido guardado' :
         locale == 'en' ? 'Join your friends to your trips and share your favourite content' :
         locale == 'fr' ? 'Rejoignez vos amis à vos voyages et partagez votre contenu préféré' : 'Присоединяйтесь к друзьям в ваши поездки и делитесь любимым контентом'}
      </p>
      <p className="text-l flex mb-5">
        <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
        {locale == 'es' ? 'Filtralo en el mapa según lo que te apetezca' :
         locale == 'en' ? 'Filter it in the map depending on your mood' :
         locale == 'fr' ? 'Filtrez-le dans la carte selon votre humeur' : 'Отфильтруйте его на карте в зависимости от вашего настроения'}
      </p>
      <p className="text-l flex mb-5">
        <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
        {locale == 'es' ? 'Reserva experiencias, hoteles y vuelos con nuestros partners' :
         locale == 'en' ? 'Book experiences, hotels and flights with our partners' :
         locale == 'fr' ? 'Réservez des expériences, des hôtels et des vols avec nos partenaires' : 'Забронируйте опыт, отели и рейсы с нашими партнерами'}
      </p>
    </div>
  </div>
</section>




<section id="NEVERFORGET" className="relative flex flex-col items-center justify-center pt-5 md:inline-grid md:grid-cols-2 md:gap-4 ml-[0%] lg:ml-[15%]">
  <div className="text-white flex flex-col mx-14 text-[18px] !text-black">
    <h3 className="text-2xl text-[#00F3CD] mb-5">
      {locale == 'es' ? 'NEVER FORGET' : 
       locale == 'en' ? 'NEVER FORGET' : 
       locale == 'fr' ? 'NE JAMAIS OUBLIER' : 'НИКОГДА НЕ ЗАБЫВАЙ'}
    </h3>
    <h4 className="text-[62px] font-bold leading-[60px] mb-10">
      {locale == 'es' ? 'Rememora e Inspira' : 
       locale == 'en' ? 'Remember and Inspire' : 
       locale == 'fr' ? 'Rappelez-vous et inspirez' : 'Помни и вдохновляй'}
    </h4>
    <p className="text-l mb-5">
      {locale == 'es' ? 'Rememora tus viajes e inspira a otros viajeros' : 
       locale == 'en' ? 'Remember your trips and inspire other travellers' : 
       locale == 'fr' ? 'Souvenez-vous de vos voyages et inspirez les autres voyageurs' : 
       'Помни о своих поездках и вдохновляй других'}
    </p>
    <p className="text-l flex mb-5">
      <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
      {locale == 'es' ? 'Crea tu perfil viajero y sigue a tus travellers favoritos' : 
       locale == 'en' ? 'Create your traveller profile and follow your favourite travellers' : 
       locale == 'fr' ? 'Créez votre profil de voyageur et suivez vos voyageurs préférés' : 
       'Создай свой профиль путешественника и следи за любимыми путешественниками'}
    </p>
    <p className="text-l flex mb-5">
      <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
      {locale == 'es' ? 'Publica álbumes de tus viajes y rememóralos' : 
       locale == 'en' ? 'Post albums from your trips to keep their memory forever' : 
       locale == 'fr' ? 'Publiez des albums de vos voyages pour garder leur souvenir pour toujours' : 
       'Публикуй альбомы о своих путешествиях, чтобы навсегда сохранить воспоминания о них'}
    </p>
    <p className="text-l flex mb-5">
      <Image quality={80} src={Ok} className="w-[20px] h-[20px] mr-5" alt=""></Image>
      {locale == 'es' ? 'Inspira con tus viajes y experiencias' : 
       locale == 'en' ? 'Inspire with your trips and experiences' : 
       locale == 'fr' ? 'Inspirez-vous avec vos voyages et expériences' : 
       'Вдохновляй других своими путешествиями и опытом'}
    </p>
  </div>
  
  <div className="flex items-center justify-center w-[400px] overflow-x-hidden mt-4">
    <Swiper 
      style={{ "--swiper-navigation-color": '#00F3CD' } as CSSProperties} 
      grabCursor={true}
      initialSlide={1}
      navigation={true}
      centeredSlides={true}
      slidesPerView={1}
      spaceBetween={350}
      autoplay={{
        disableOnInteraction: false,
        delay: 5000
      }}
      modules={[Navigation, Autoplay]}
      className="!h-[100] !w-[200%]"
    >
      <SwiperSlide className=" ">
        <div className="!w-[1000%] ml-[4px]">
          <Image quality={80} src='https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Remember/1.webp' alt={""} width={600} height={500}/>
        </div>
      </SwiperSlide>
      <SwiperSlide className="">
        <div className="!w-[1000%] ml-[364px]">
          <Image quality={80} src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/Remember/2.webp'} alt={""} width={500} height={500}/>
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</section>




      <section className="relative flex flex-col items-center justify-center   pt-5     w-full h-15"> 
        <div className="text-black text-center align-center  items-center justify-center  border-solid border-[1px] border-[#00F3CD] h-12 w-0 ">

        </div>
      </section>
      <section id="COMMENTS" className="mb-4 align-center  items-center justify-center  text-center w-full mx-auto flex">

      <div className="w-full bg-[#E7E7E770] pb-14 max-w-[1400px] rounded-3xl">
  <div className="relative flex flex-col items-center justify-center pt-0 w-full h-15"> 
    <div className="text-black text-center align-center items-center justify-center border-solid border-[1px] border-[#00F3CD] h-12 w-0 ">
    </div>
  </div>
  <div className="items-center justify-center text-center align-center">
    <h3 className="text-[#00F3CD] text-[19px] tracking-[3px] font-semibold mt-8">
      {locale == 'es' ? 'QUÉ DICE LA COMUNIDAD' :
       locale == 'en' ? 'SEE WHAT ARE OTHERS SAYING' :
       locale == 'fr' ? 'VOIR CE QUE DISENT LES AUTRES' :
       locale == 'ru' ? 'ПОСМОТРИТЕ, ЧТО ГОВОРЯТ ДРУГИЕ' : ''}
    </h3>
    <h2 className="text-black text-[62px] tracking-[3px] font-bold mt-0">
      {locale == 'es' ? 'Nuestros Viajeros' :
       locale == 'en' ? `Traveller's thoughts` :
       locale == 'fr' ? 'Nos Voyageurs' :
       locale == 'ru' ? 'Наши Путешественники' : ''}
    </h2>
  </div>
</div>

      </section>
      <section className="relative flex flex-col items-center justify-center   pt-5     w-full h-30 mt-4"> 
        <div className="text-black text-center align-center  items-center justify-center  border-solid border-[1px] border-[#00F3CD] h-20 w-0 ">

        </div>
      </section>
      <section id="BREAKTHEROUTINE" className="!overflow-y-hidden mt-20">
  <div className="text-[30px] md:text-[40px] lg:text-[64px] mb-32 md:mb-40 text-center font-black opacity-[0.8] leading-[1.1]">
    <h2>
      {locale === 'es' ? 'Rompe la rutina,' : 
      locale === 'en' ? 'Break the routine,' : 
      locale === 'fr' ? 'Briser la routine,' :
      locale === 'ru' ? 'Разорви рутину,' : ''}
      <br />
      {locale === 'es' ? 'únete a be' : 
      locale === 'en' ? 'join be' : 
      locale === 'fr' ? 'rejoignez be' :
      locale === 'ru' ? 'присоединяйся к be' : ''}
      <span className="text-[#00F3CD]">der </span>
      {locale === 'es' ? 'y disfruta el ' : 
      locale === 'en' ? 'and enjoy the ' : 
      locale === 'fr' ? 'et profitez du ' : 
      locale === 'ru' ? 'и наслаждайся ' : ''}
      <span className="text-[#00F3CD]">
        {locale === 'es' ? 'mundo' : 
        locale === 'en' ? 'world!' : 
        locale === 'fr' ? 'monde!' : 
        locale === 'ru' ? 'миром!' : ''}
      </span>
    </h2>
  </div>

  <div className="-mt-[15%] md:-mt-[5%] -mb-[9%] !overflow-y-hidden">
    <div className="-mt-[9%]">
      <VideoJS
        options={{
          autoplay: true,
          controls: false,
          muted: true,
          controlBar: {
            fullscreenToggle: false,
            pictureInPictureToggle: false,
          },
          loop: true,
          fluid: true,
          playsinline: true,
          preload: 'auto',
        }}
        play={true}
        src={'https://storage.googleapis.com/theapp.res.beder.app/dev/theapp/1878126663.mp4'}
        poster={''}
      />
    </div>
  </div>
</section>

<section className="relative flex flex-col items-center justify-center pt-5 md:inline-grid grid grid-cols-2 md:grid-cols-4 md:gap-2 w-screen my-5">
  <div className="text-black text-center align-center mx-auto items-center justify-center my-5">
    <h4 className="text-[36px] opacity-[0.7] font-bold ">400<span className="text-[#00F3CD]">+</span></h4>
    <h3 className="text-[15px]">
      {locale === 'es' ? 'NÚMERO DE DESTINOS' : 
      locale === 'en' ? 'NUMBER OF DESTINATIONS' : 
      locale === 'fr' ? 'NOMBRE DE DESTINATIONS' : 
      locale === 'ru' ? 'направлений' : ''}
    </h3>
  </div>
  
  <div className="text-black text-center align-center mx-auto items-center justify-center my-5">
    <h4 className="text-[36px] opacity-[0.7] font-bold ">40000<span className="text-[#00F3CD]">+</span></h4>
    <h3 className="text-[15px]">
      {locale === 'es' ? 'NÚMERO DE VIDEOS' : 
      locale === 'en' ? 'NUMBER OF VIDEOS' : 
      locale === 'fr' ? 'NOMBRE DE VIDÉOS' : 
      locale === 'ru' ? 'пользователей' : ''}
    </h3>
  </div>

  <div className="text-black text-center align-center mx-auto items-center justify-center my-5">
    <h4 className="text-[36px] opacity-[0.7] font-bold ">10000<span className="text-[#00F3CD]">+</span></h4>
    <h3 className="text-[15px]">
      {locale === 'es' ? 'NÚMERO DE USUARIOS' : 
      locale === 'en' ? 'NUMBER OF USERS' : 
      locale === 'fr' ? `NOMBRE D'UTILISATEURS` : 
      locale === 'ru' ? 'ЧИСЛО ПОЛЬЗОВАТЕЛЕЙ' : ''}
    </h3>
  </div>

  <div className="text-black text-center align-center mx-auto items-center justify-center my-5">
    <h4 className="text-[36px] opacity-[0.7] font-bold ">100<span className="text-[#00F3CD]">%</span></h4>
    <h3 className="text-[15px]">
      {locale === 'es' ? 'GANAS DE VIAJAR' : 
      locale === 'en' ? 'HUNGER FOR TRAVELLING' : 
      locale === 'fr' ? 'FAIM DE VOYAGE' : 
      locale === 'ru' ? 'ЖАЖДА ПУТЕШЕСТВИЙ' : ''}
    </h3>
  </div>
</section>

        <section className="relative flex flex-col items-center justify-center   pt-5     w-full h-30"> 
          <div className="text-black text-center align-center  items-center justify-center  border-solid border-[1px] border-[#00F3CD] h-20 w-0 ">

          </div>
        </section>
        <section className="relative flex flex-col items-center justify-center pt-5 w-full h-30 mb-20"> 
  <h3 className="text-black text-center align-center text-[54px] font-black items-center justify-center border-solid">
    {locale === 'es' ? 'Disponible en' : 
    locale === 'en' ? 'Available on' : 
    locale === 'fr' ? 'Disponible sur' : 
    locale === 'ru' ? 'Доступно в' : ''}
  </h3>
  
  <div className="grid grid-cols-2 mt-4">
    <a href="https://apps.apple.com/app/beder-l-explore-travel/id1609301338" target="_blank" rel="noreferrer">
      <div className="text-black text-center align-center text-[54px] font-black items-center justify-center border-solid mx-4">
        <Image quality={80} className="w-[230px]" src={Appstore} alt="" />
      </div>
    </a>

    <a href="https://play.google.com/store/apps/details?id=com.bederapp" target="_blank" rel="noreferrer">
      <div className="text-black text-center align-center text-[54px] font-black items-center justify-center border-solid mx-4">
        <Image quality={80} className="w-[230px]" src={Googleplay} alt="" />
      </div>
    </a>
  </div>
</section>

     
      
    </MainLayout>

  );
}


